import React, { Component } from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant?.js'
import axios from 'axios'
import Moment from 'react-moment'
import moment from 'moment'
import { getCountryTimeZone, getCurrency, getVat } from '../../Constant.js'
import { WaveLoading } from 'react-loadingg'
import 'react-responsive-modal/styles.css'
import { withTranslation } from 'react-i18next'

class CruiseBookingDetail extends Component {
  state = {
    bookingData: null,
    currency: getCurrency('KWT'),
    country: 'KWT',
    total_Vat: 0,
    additional_hr: 0,
    additional_hr_price: 0,
    isLoading: false,
  }

  style = {
    tableData: {
      padding: 5,
      paddingLeft: 10,
      border: '1px solid #ddd',
    },
    tableDataUnpaid: {
      background: '#f77',
      color: '#fff',
      fontWeight: 'bold',
    },
    tableDataPaid: {
      background: '#eee',
    },
  }

  componentDidMount() {
    this.getBookingDetails()
  }

  getBookingDetails = async () => {
    await axios
      .get(Constant?.getAPI() + '/booking/booking-details/' + this.props?.match?.params?.booking_id, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState(
            {
              bookingData: res?.data?.data,
              currency: getCurrency(res?.data?.data?.country),
              country: res?.data?.data?.country,
            },
            async () => {
              let tempBookingDetails = this.state?.bookingData

              tempBookingDetails.slots.sort((a, b) => a?.slot_from?.localeCompare(b?.slot_from))
              tempBookingDetails.slots.sort((a, b) => a?.slot_date?.localeCompare(b?.slot_date))

              if (tempBookingDetails?.payment_details?.length > 0) {
                tempBookingDetails.payment_details.sort((a, b) => moment(a.created_at) - moment(b.created_at))
              }

              this.setState(
                {
                  bookingData: tempBookingDetails,
                },
                () => {
                  // set additional Hours
                  let destinationHours = this.state?.bookingData?.destination?.destination_min_hour.slice(0, 2)
                  if (this.state?.bookingData?.slots.length > parseInt(destinationHours)) {
                    this.setState({
                      additional_hr: this.state?.bookingData?.slots.length - parseInt(destinationHours),
                    })
                  }
                  // Calculate Vat
                  let vat = getVat(this.state?.country)
                  let vat_included_amount =
                    this.state?.bookingData?.total_booking_amount + this.state?.bookingData?.wallet_amount_applied

                  if (vat_included_amount > 0) {
                    this.setState({
                      total_Vat: vat_included_amount - vat_included_amount / (1 + vat / 100),
                    })
                  }
                }
              )
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  showDetails = (type) => {
    const currentLanguage = localStorage.getItem('selectedLanguage') || 'en'
    const isArabic = currentLanguage === 'ar'
    const textAlign = isArabic ? 'right' : 'left'

    switch (type) {
      case 'pickup':
        Swal.fire({
          width: '800px',
          title: `<strong>${this.props.t('Pickup Details')}</strong>`,
          html: `
            <table style="width: 100%; direction: ${isArabic ? 'rtl' : 'ltr'}">
              <tbody>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Address')}</th>
                  <td style="text-align: ${textAlign}">
                    ${
                      isArabic
                        ? this.state?.bookingData?.pickup?.pickup_address_ar
                        : this.state?.bookingData?.pickup?.pickup_address_en || '--'
                    }
                  </td>
                </tr>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Description')}</th>
                  <td style="text-align: ${textAlign}">${this.state?.bookingData?.pickup?.pickup_desc || '--'}</td>
                </tr>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Latitude')}</th>
                  <td style="text-align: ${textAlign}">${this.state?.bookingData?.pickup?.pickup_lat || '--'}</td>
                </tr>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Longitude')}</th>
                  <td style="text-align: ${textAlign}">${this.state?.bookingData?.pickup?.pickup_long || '--'}</td>
                </tr>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Map')}</th>
                  <td style="text-align: ${textAlign}">${this.state?.bookingData?.pickup?.pickup_map || '--'}</td>
                </tr>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Other Detail')}</th>
                  <td style="text-align: ${textAlign}">${this.state?.bookingData?.pickup?.pickup_other_detail || '--'}</td>
                </tr>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Vendor Name')}</th>
                  <td style="text-align: ${textAlign}">
                    ${this.state?.bookingData?.pickup?.wave_pickup?.vendor?.first_name} 
                    ${this.state?.bookingData?.pickup?.wave_pickup?.vendor?.last_name}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Vendor Charge')}</th>
                  <td style="text-align: ${textAlign}">
                    ${this.state?.bookingData?.pickup?.wave_pickup?.pickup_vendor_charge || '--'}
                  </td>
                </tr>
              </tbody>
            </table>
          `,
        })
        break
      case 'destination':
        Swal.fire({
          width: '800px',
          title: `<strong>${this.props.t('Destination Details')}</strong>`,
          html: `
            <table style="width: 100%; direction: ${isArabic ? 'rtl' : 'ltr'}">
              <tbody>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Address')}</th>
                  <td style="text-align: ${textAlign}">
                    ${
                      isArabic
                        ? this.state?.bookingData?.destination?.destination_address_ar
                        : this.state?.bookingData?.destination?.destination_address_en || '--'
                    }
                  </td>
                </tr>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Latitude')}</th>
                  <td style="text-align: ${textAlign}">${this.state?.bookingData?.destination?.destination_lat || '--'}</td>
                </tr>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Longitude')}</th>
                  <td style="text-align: ${textAlign}">${this.state?.bookingData?.destination?.destination_long || '--'}</td>
                </tr>
                <tr>
                  <th style="text-align: ${textAlign}">${this.props.t('Hours')}</th>
                  <td style="text-align: ${textAlign}">${this.state?.bookingData?.destination?.destination_min_hour || '--'}</td>
                </tr>
              </tbody>
            </table>
          `,
        })
        break
      case 'payment':
        var content
        if (this.state?.bookingData?.payment_details.length > 0) {
          content = `
            <div>
              <table style="width:100%; direction: ${isArabic ? 'rtl' : 'ltr'}">
                <tbody>
                  <tr>
                    <th style="text-align: ${textAlign}"></th>
                    ${this.state?.bookingData?.payment_details.map(
                      (item, index) =>
                        `<th style="text-align: ${textAlign}">${this.props.t('Payment')} ${index + 1}</th>`
                    )}
                  </tr>
                  <tr>
                    <th style="text-align: ${textAlign}">${this.props.t('Payment ID')}</th>
                    ${this.state?.bookingData?.payment_details.map(
                      (item) => `<td style="text-align: ${textAlign}">${item.payment_id || '--'}</td>`
                    )}
                  </tr>
                  <tr>
                    <th style="text-align: ${textAlign}">${this.props.t('Payment Status')}</th>
                    ${this.state?.bookingData?.payment_details.map(
                      (item) => `<td style="text-align: ${textAlign}">${item.payment_status || '--'}</td>`
                    )}
                  </tr>
                  <tr>
                    <th style="text-align: ${textAlign}">${this.props.t('Payment Method')}</th>
                    ${this.state?.bookingData?.payment_details.map(
                      (item) =>
                        `<td style="text-align: ${textAlign}">${
                          isArabic
                            ? item?.payment_method?.PaymentMethod_ar
                            : item?.payment_method?.PaymentMethod_en || '--'
                        }</td>`
                    )}
                  </tr>
                  <tr>
                    <th style="text-align: ${textAlign}">${this.props.t('Payment Amount')}</th>
                    ${this.state?.bookingData?.payment_details.map(
                      (item) =>
                        `<td style="text-align: ${textAlign}">${item.payment_currency || this.state.currency} ${item.payment_amount}</td>`
                    )}
                  </tr>
                  <tr>
                    <th style="text-align: ${textAlign}">${this.props.t('Transaction ID')}</th>
                    ${this.state?.bookingData?.payment_details.map(
                      (item) => `<td style="text-align: ${textAlign}">${item.txn_id || '--'}</td>`
                    )}
                  </tr>
                  <tr>
                    <th style="text-align: ${textAlign}">${this.props.t('Invoice Reference ID')}</th>
                    ${this.state?.bookingData?.payment_details.map(
                      (item) =>
                        `<td style="text-align: ${textAlign}">${item.payment_info.InvoiceReference || '--'}</td>`
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          `

          Swal.fire({
            width: '1000px',
            title: `<strong>${this.props.t('Payment Details')}</strong>`,
            html: content,
          })
        } else {
          Swal.fire({
            title: `<strong>${this.props.t('Payment Details Not Found')}</strong>`,
            icon: 'error',
            type: 'error',
          })
        }
        break
      default:
        break
    }
  }

  handleChange = (event) => {
    event.preventDefault()
    this.setState({ [event.target.name]: event.target.value })
  }

  render() {
    const currentLanguage = localStorage.getItem('selectedLanguage') || 'en'
    const isArabic = currentLanguage === 'ar'
    const textAlign = isArabic ? 'right' : 'left'
    const flexDirection = isArabic ? 'row-reverse' : 'row'

    const tableHeaderStyle = {
      padding: '8px 10px',
      textAlign: isArabic ? 'right' : 'left',
      borderRight: isArabic ? 'none' : '1px solid #ddd',
      borderLeft: isArabic ? '1px solid #ddd' : 'none',
    }

    const tableDataStyle = {
      ...this.style.tableData,
      textAlign: isArabic ? 'right' : 'left',
      paddingRight: isArabic ? '10px' : '5px',
      paddingLeft: isArabic ? '5px' : '10px',
      borderRight: isArabic ? 'none' : '1px solid #ddd',
      borderLeft: isArabic ? '1px solid #ddd' : 'none',
    }

    const sectionStyle = {
      fontWeight: 'bold',
      textAlign,
      marginBottom: '10px',
      paddingRight: isArabic ? '10px' : '0',
      paddingLeft: isArabic ? '0' : '10px',
    }

    const columnStyle = {
      borderRight: isArabic ? 'none' : '1px solid #ddd',
      borderLeft: isArabic ? '1px solid #ddd' : 'none',
      paddingRight: isArabic ? '15px' : '5px',
      paddingLeft: isArabic ? '5px' : '15px',
    }

    const iconStyle = {
      width: 13,
      marginLeft: isArabic ? '5px' : '0',
      marginRight: isArabic ? '0' : '5px',
      cursor: 'pointer',
    }

    const tableStyle = {
      direction: isArabic ? 'rtl' : 'ltr',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
    }

    const contentStyle = {
      direction: isArabic ? 'rtl' : 'ltr',
      textAlign,
    }

    return (
      <div
        className="pcoded-inner-content"
        dir={isArabic ? 'rtl' : 'ltr'}
        style={contentStyle}
      >
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
            }}
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <WaveLoading />
          </div>
        )}
        <div className="main-body">
          <div className="page-wrapper">
            <div
              className="page-header"
              id="store-order-header"
            >
              <div
                className="row align-items-end"
                style={{ flexDirection }}
              >
                <div className="col-3">
                  <div
                    className="page-header-title"
                    style={{ textAlign }}
                  >
                    <div className="d-inline">
                      <h4>{this.props.t('Booking Details')}</h4>
                    </div>
                  </div>
                </div>
                {this.state?.bookingData && (
                  <div
                    className="col-9"
                    style={{ textAlign }}
                  ></div>
                )}
              </div>
            </div>
            <div
              className="page-body"
              id="store-order-details"
            >
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div
                      className="card-block"
                      style={contentStyle}
                    >
                      {this.state?.bookingData ? (
                        <>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd', flexDirection }}
                          >
                            <div
                              className="col-md-6 col-sm-12"
                              style={columnStyle}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10, flexDirection }}
                              >
                                <div
                                  className="col-3"
                                  style={sectionStyle}
                                >
                                  <div>{this.props.t('Booking Details')}</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ ...sectionStyle, fontWeight: 'bold' }}
                                >
                                  <div>{this.props.t('Booking ID')}</div>
                                  <div>{this.props.t('Booking Status')}</div>
                                  <div>{this.props.t('Booking Type tag')}</div>
                                  <div>{this.props.t('Booking Date')}</div>
                                  <div>{this.props.t('Issue date & Time')}</div>
                                  <div>{this.props.t('Booking Duration')}</div>
                                  <div>{this.props.t('TimeSlots')}</div>
                                </div>
                                <div
                                  className="col-5"
                                  style={{ textAlign }}
                                >
                                  <div style={{ fontWeight: 'bolder' }}>
                                    {this.state.bookingData?.order_number || '--'}
                                    {this.state.bookingData?.from_flash_offer == true && (
                                      <img
                                        src={'./assets/images/ic_flash_icon.png'}
                                        alt="img"
                                        onError={(event) => {
                                          event.currentTarget.src = './assets/images/ic_flash_icon.png'
                                        }}
                                        style={{
                                          height: 20,
                                          marginLeft: isArabic ? '0' : '5px',
                                          marginRight: isArabic ? '5px' : '0',
                                        }}
                                      />
                                    )}
                                  </div>
                                  <div style={{ fontWeight: 'bolder', color: 'green' }}>
                                    {this.state?.bookingData?.booking_status == 'Cancelled' ||
                                    this.state?.bookingData?.booking_cancel ? (
                                      <span className="badge badge-pill badge-warning">
                                        {this.props.t('Cancelled')}
                                      </span>
                                    ) : this.state?.bookingData?.booking_status == 'Confirmed' ? (
                                      <span className="badge badge-pill badge-success">
                                        {this.props.t('Confirmed')}
                                      </span>
                                    ) : this.state?.bookingData?.booking_status == 'Postponed' ? (
                                      <span className="badge badge-pill badge-warning">
                                        {this.props.t('Postponed')}
                                      </span>
                                    ) : this.state?.bookingData?.booking_status == 'Successful' ? (
                                      <span className="badge badge-pill badge-success">
                                        {this.props.t('Successful')}
                                      </span>
                                    ) : this.state?.bookingData?.booking_status == 'Pending' &&
                                      this.state?.bookingData?.is_concierge_booking == true &&
                                      this.state?.bookingData?.payment_status == false ? (
                                      <span className="badge badge-pill badge-warning">
                                        {this.props.t('Payment Pending')}
                                      </span>
                                    ) : this.state?.bookingData?.booking_status == 'Pending' &&
                                      this.state?.bookingData?.payment_status == true ? (
                                      <span className="badge badge-pill badge-warning">
                                        {this.props.t('In Progress')}
                                      </span>
                                    ) : (
                                      <span className="badge badge-pill badge-warning">--</span>
                                    )}
                                  </div>
                                  <div>{this.state?.bookingData?.type_tag || '--'}</div>
                                  <div>
                                    {this.state?.bookingData?.booking_date || '--'}
                                    {' - '}
                                    {this.state?.bookingData?.slots[this.state?.bookingData?.slots?.length - 1]
                                      ?.slot_date
                                      ? this.state?.bookingData?.slots[this.state?.bookingData?.slots?.length - 1]
                                          ?.slot_date
                                      : this.state?.bookingData?.booking_date || '--'}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.payment_details &&
                                    this.state?.bookingData?.payment_details?.length > 0 ? (
                                      <Moment
                                        format="YYYY-MM-DD HH:mm A"
                                        tz={getCountryTimeZone(localStorage.getItem('countryShortName'))}
                                      >
                                        {this.state?.bookingData?.payment_details[0].created_at}
                                      </Moment>
                                    ) : (
                                      <Moment
                                        format="YYYY-MM-DD HH:mm A"
                                        tz={getCountryTimeZone(localStorage.getItem('countryShortName'))}
                                      >
                                        {this.state?.bookingData?.created_at}
                                      </Moment>
                                    )}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.slots.length}
                                    {this.state?.bookingData?.slots.length > 1
                                      ? ` ${this.props.t('Hrs.')}`
                                      : ` ${this.props.t('Hr.')}`}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.slots &&
                                      this.state?.bookingData?.slots.map((slot, i) => {
                                        return (
                                          <span key={i}>
                                            {slot.slot_from.substring(0, 5) + ', '}
                                            {i == this.state?.bookingData?.slots.length - 1 &&
                                              slot.slot_to.substring(0, 5)}
                                          </span>
                                        )
                                      })}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <div
                                className="row"
                                style={{ marginBottom: 10, flexDirection }}
                              >
                                <div
                                  className="col-3"
                                  style={sectionStyle}
                                >
                                  <div>{this.props.t('User Details')}</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ ...sectionStyle, fontWeight: 'bold' }}
                                >
                                  <div>{this.props.t('Customer Name')}</div>
                                </div>
                                <div
                                  className="col-5"
                                  style={{ textAlign }}
                                >
                                  <div style={{ textTransform: 'capitalize' }}>
                                    {!this.state?.bookingData?.customer?.first_name &&
                                    !this.state?.bookingData?.customer?.last_name &&
                                    this.state?.bookingData?.customer?.is_guest
                                      ? this.props.t('Guest User')
                                      : this.state?.bookingData?.customer?.first_name &&
                                          this.state?.bookingData?.customer?.last_name
                                        ? this.state?.bookingData?.customer?.first_name +
                                          ' ' +
                                          this.state?.bookingData?.customer?.last_name
                                        : '--'}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd', flexDirection }}
                          >
                            <div
                              className="col-6"
                              style={columnStyle}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10, flexDirection }}
                              >
                                <div
                                  className="col-3"
                                  style={sectionStyle}
                                >
                                  <div>{this.props.t('Cruise Details')}</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ ...sectionStyle, fontWeight: 'bold' }}
                                >
                                  <div>{this.props.t('Cruise Name')}</div>
                                  <div>
                                    {this.props.t('Pickup position')}
                                    <img
                                      className="img-fluid"
                                      src="./assets/images/info.png"
                                      alt="ico"
                                      style={iconStyle}
                                      onClick={() => this.showDetails('pickup')}
                                    />
                                  </div>
                                  <div>
                                    {this.props.t('Destination')}
                                    <img
                                      className="img-fluid"
                                      src="./assets/images/info.png"
                                      alt="ico"
                                      style={iconStyle}
                                      onClick={() => this.showDetails('destination')}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col-5"
                                  style={{ textAlign }}
                                >
                                  <div>
                                    {isArabic
                                      ? this.state?.bookingData?.cruise?.cruise_name_ar
                                      : this.state?.bookingData?.cruise?.cruise_name_en || '--'}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.source_pickup
                                      ? isArabic
                                        ? this.state?.bookingData?.source_pickup?.pickup_address_ar
                                        : this.state?.bookingData?.source_pickup?.pickup_address_en
                                      : isArabic
                                        ? this.state?.bookingData?.pickup?.pickup_address_ar
                                        : this.state?.bookingData?.pickup?.pickup_address_en || '--'}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.source_destination
                                      ? isArabic
                                        ? this.state?.bookingData?.source_destination.destination_address_ar
                                        : this.state?.bookingData?.source_destination.destination_address_en
                                      : isArabic
                                        ? this.state?.bookingData?.destination?.destination_address_ar
                                        : this.state?.bookingData?.destination?.destination_address_en || '--'}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div
                                className="row"
                                style={{ marginBottom: 10, flexDirection }}
                              >
                                <div
                                  className="col-4"
                                  style={sectionStyle}
                                >
                                  <div>{this.props.t('Captain Details')}</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ ...sectionStyle, fontWeight: 'bold' }}
                                >
                                  <div>{this.props.t('Captain Name')}</div>
                                  <div>{this.props.t('Captain Phone')}</div>
                                  <div>{this.props.t('Captain Email')}</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ textAlign }}
                                >
                                  <div>
                                    {this.state?.bookingData?.cruise?.captain?.first_name}{' '}
                                    {this.state?.bookingData?.cruise?.captain?.last_name}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.cruise?.captain?.country_code}{' '}
                                    {this.state?.bookingData?.cruise?.captain?.phone}
                                    {this.state.whatsAppShare != 'captain' ? (
                                      <a
                                        title={this.props.t('Booking Detail Share')}
                                        onClick={() =>
                                          this.getBookingShareLink(
                                            this.state.bookingData.cruise.captain.phone,
                                            this.state.bookingData.cruise.captain.country_code,
                                            this.state.bookingData.order_number,
                                            'captain'
                                          )
                                        }
                                      >
                                        <img
                                          className="img-fluid"
                                          src="./assets/images/whatsapp.png"
                                          alt="ico"
                                          style={iconStyle}
                                        />
                                      </a>
                                    ) : (
                                      <>
                                        <WaveLoading
                                          color="#46C655"
                                          size="small"
                                        />
                                      </>
                                    )}
                                  </div>
                                  <div>{this.state?.bookingData?.cruise?.captain?.email || '--'}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12"
                            style={{ padding: 10 }}
                          >
                            <div className="row">
                              <div
                                className="col-2"
                                style={sectionStyle}
                              >
                                {this.props.t('Add-ons')}
                              </div>
                              <div className="col-10">
                                <div className="table-responsive">
                                  <table
                                    className="table"
                                    style={tableStyle}
                                  >
                                    <tbody>
                                      <tr
                                        className="thead-inverse"
                                        style={{ height: 40 }}
                                      >
                                        <th style={tableHeaderStyle}>{this.props.t('Amount Goes To')}</th>
                                        <th style={tableHeaderStyle}>{this.props.t('Shop Name')}</th>
                                        <th style={tableHeaderStyle}>{this.props.t('Item Name')}</th>
                                        <th style={tableHeaderStyle}>{this.props.t('Category')}</th>
                                        <th style={tableHeaderStyle}>{this.props.t('Special Request')}</th>
                                        <th style={tableHeaderStyle}>{this.props.t('Payment status')}</th>
                                        <th style={tableHeaderStyle}>{this.props.t('Quantity')}</th>
                                      </tr>
                                      {this.state?.bookingData?.diwaniya_items?.length > 0 &&
                                        this.state?.bookingData?.diwaniya_items.map((item) => (
                                          <tr
                                            key={item.id}
                                            style={
                                              item?.payment_status
                                                ? this.style.tableDataPaid
                                                : this.style.tableDataUnpaid
                                            }
                                          >
                                            <td style={tableDataStyle}>
                                              {item?.cruise_diwaniya?.diwaniya_master?.source || 'OWNER'}
                                            </td>
                                            <td style={tableDataStyle}>
                                              {isArabic
                                                ? item?.cruise_diwaniya?.diwaniya_master?.wave_store?.shop_name_ar
                                                : item?.cruise_diwaniya?.diwaniya_master?.wave_store?.shop_name_en ||
                                                  '--'}
                                            </td>
                                            <td style={tableDataStyle}>
                                              {isArabic
                                                ? item?.cruise_diwaniya?.item_name_ar
                                                : item?.cruise_diwaniya?.item_name_en || '--'}
                                            </td>
                                            <td style={tableDataStyle}>
                                              {isArabic
                                                ? item?.cruise_diwaniya?.category?.name_ar
                                                : item?.cruise_diwaniya?.category?.name_en || '--'}
                                            </td>
                                            <td style={tableDataStyle}>{item.notes || '--'}</td>
                                            <td style={tableDataStyle}>
                                              {item?.payment_status === true ? (
                                                <span className="badge badge-success">{this.props.t('Success')}</span>
                                              ) : (
                                                <span className="badge badge-danger">{this.props.t('Pending')}</span>
                                              )}
                                            </td>
                                            <td style={tableDataStyle}>{item.item_qty || '--'}</td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div
                                className="col-2"
                                style={sectionStyle}
                              >
                                {this.props.t('Waves Market')}
                              </div>
                              <div className="col-10">
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="table-responsive">
                                      <table className="table">
                                        <tbody>
                                          <tr
                                            className="thead-inverse"
                                            style={{ height: 40 }}
                                          >
                                            <th style={tableHeaderStyle}>{this.props.t('Shop Name')}</th>
                                            <th style={tableHeaderStyle}>{this.props.t('Item Name')}</th>
                                            <th style={tableHeaderStyle}>SKU</th>
                                            <th style={tableHeaderStyle}>{this.props.t('Special Request')}</th>
                                            <th style={tableHeaderStyle}>{this.props.t('Payment status')}</th>
                                            <th style={tableHeaderStyle}>{this.props.t('Quantity')}</th>
                                          </tr>
                                          {this.state?.bookingData?.additional_items?.length > 0 &&
                                            this.state?.bookingData?.additional_items
                                              .filter((item) => item?.store_item?.store?.shop_type == 'FOOD')
                                              .sort((a, b) => {
                                                const storeNameA = a.store_item.store.shop_name_en.toUpperCase()
                                                const storeNameB = b.store_item.store.shop_name_en.toUpperCase()

                                                if (storeNameA < storeNameB) return -1
                                                if (storeNameA > storeNameB) return 1
                                                return 0
                                              })
                                              .map((item) => {
                                                return (
                                                  <tr
                                                    key={item.id}
                                                    style={
                                                      item?.payment_status
                                                        ? this.style.tableDataPaid
                                                        : this.style.tableDataUnpaid
                                                    }
                                                  >
                                                    <td style={tableDataStyle}>
                                                      {isArabic
                                                        ? item?.store_item?.store?.shop_name_ar
                                                        : item?.store_item?.store?.shop_name_en || '--'}
                                                    </td>
                                                    <td style={tableDataStyle}>
                                                      {isArabic
                                                        ? item?.store_item?.item_name_ar
                                                        : item?.store_item?.item_name_en || '--'}
                                                      {item?.store_item_option?.name_en && (
                                                        <span className="text-danger">
                                                          {`(${isArabic ? item.store_item_option.name_ar : item.store_item_option.name_en})`}
                                                        </span>
                                                      )}
                                                    </td>
                                                    <td style={tableDataStyle}>{item?.store_item?.sku || '--'}</td>
                                                    <td style={tableDataStyle}>{item?.notes || '--'}</td>
                                                    <td style={tableDataStyle}>
                                                      {item?.payment_status === true ? (
                                                        <span className="badge badge-success">
                                                          {this.props.t('Success')}
                                                        </span>
                                                      ) : (
                                                        <span className="badge badge-danger">
                                                          {this.props.t('Pending')}
                                                        </span>
                                                      )}
                                                    </td>
                                                    <td style={tableDataStyle}>{item.item_qty || '--'}</td>
                                                  </tr>
                                                )
                                              })}
                                          {this.state?.bookingData?.bulkCoupon?.coupon_type == 'drink' && (
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={{ ...tableDataStyle, color: 'green', fontWeight: 'bold' }}>
                                                {this.props.t('Free Drinks')}
                                              </td>
                                              <td style={tableDataStyle}>--</td>
                                              <td style={tableDataStyle}>--</td>
                                              <td style={tableDataStyle}>--</td>
                                              <td style={{ ...tableDataStyle, color: 'green', fontWeight: 'bold' }}>
                                                {this.state?.bookingData?.bulkCoupon?.no_of_drinks || 0}
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div
                                className="col-2"
                                style={sectionStyle}
                              >
                                {this.props.t('Stores')}
                              </div>
                              <div className="col-10">
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="table-responsive">
                                      <table className="table">
                                        <tbody>
                                          <tr
                                            className="thead-inverse"
                                            style={{ height: 40 }}
                                          >
                                            <th style={tableHeaderStyle}>{this.props.t('Shop Name')}</th>
                                            <th style={tableHeaderStyle}>{this.props.t('Item Name')}</th>
                                            <th style={tableHeaderStyle}>SKU</th>
                                            <th style={tableHeaderStyle}>{this.props.t('Special Request')}</th>
                                            <th style={tableHeaderStyle}>{this.props.t('Payment status')}</th>
                                            <th style={tableHeaderStyle}>{this.props.t('Quantity')}</th>
                                          </tr>
                                          {this.state?.bookingData?.additional_items?.length > 0 &&
                                            this.state?.bookingData?.additional_items
                                              .filter((item) => item?.store_item?.store?.shop_type == 'STORE')
                                              .sort((a, b) => {
                                                const storeNameA = a.store_item.store.shop_name_en.toUpperCase()
                                                const storeNameB = b.store_item.store.shop_name_en.toUpperCase()

                                                if (storeNameA < storeNameB) return -1
                                                if (storeNameA > storeNameB) return 1
                                                return 0
                                              })
                                              .map((item) => {
                                                return (
                                                  <tr
                                                    key={item.id}
                                                    style={
                                                      item?.payment_status
                                                        ? this.style.tableDataPaid
                                                        : this.style.tableDataUnpaid
                                                    }
                                                  >
                                                    <td style={tableDataStyle}>
                                                      {isArabic
                                                        ? item?.store_item?.store?.shop_name_ar
                                                        : item?.store_item?.store?.shop_name_en || '--'}
                                                    </td>
                                                    <td style={tableDataStyle}>
                                                      {isArabic
                                                        ? item?.store_item?.item_name_ar
                                                        : item?.store_item?.item_name_en || '--'}
                                                      {item?.store_item_option?.name_en && (
                                                        <span className="text-danger">
                                                          {`(${isArabic ? item.store_item_option.name_ar : item.store_item_option.name_en})`}
                                                        </span>
                                                      )}
                                                    </td>
                                                    <td style={tableDataStyle}>{item?.store_item?.sku || '--'}</td>
                                                    <td style={tableDataStyle}>{item?.notes || '--'}</td>
                                                    <td style={tableDataStyle}>
                                                      {item?.payment_status === true ? (
                                                        <span className="badge badge-success">
                                                          {this.props.t('Success')}
                                                        </span>
                                                      ) : (
                                                        <span className="badge badge-danger">
                                                          {this.props.t('Pending')}
                                                        </span>
                                                      )}
                                                    </td>
                                                    <td style={tableDataStyle}>{item.item_qty || '--'}</td>
                                                  </tr>
                                                )
                                              })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <h6 style={contentStyle}>{this.props.t('Details not found')}</h6>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(CruiseBookingDetail)
